import React, {Component} from 'react'
import Form from "react-bootstrap/Form"

class SizePerPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedSizePerPage: props.sizePerPage
    }
  }

  _showOptions = () => {
    const { totalSize } = this.props

    const sizePerPageList = [{
      text: '10', value: 10
    }, {
      text: '25', value: 25
    }, {
      text: 'All', value: totalSize
    }]

    return sizePerPageList.map((option, index) => {
      return (
        <option key={index} value={option.value}>{option.text}</option>
      )
    })
  }

  _handleSizePerPage = (paginationProps, newSizePerPage) => {
    const { page, onSizePerPageChange } = paginationProps
    this.setState({
      selectedSizePerPage: newSizePerPage
    }, () => {
      onSizePerPageChange(newSizePerPage, page)
    })
  }

  render() {
    const { paginationProps } = this.props
    return(
      <Form.Control
        size="sm"
        as="select"
        onChange={(e) =>  this._handleSizePerPage(paginationProps, e.target.value)}
        value={this.state.selectedSizePerPage}
        style={{minWidth: '55px'}}
      >
        {this._showOptions()}
      </Form.Control>
    )
  }
}

export default SizePerPage